import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import enGbAdmin from "./locales/en-GB/admin.json";
import enGbAnalysis from "./locales/en-GB/analysis.json";
import enGbCommon from "./locales/en-GB/common.json";
import enGbAuth from "./locales/en-GB/auth.json";
import enGbDashboard from "./locales/en-GB/dashboard.json";
import enGbDaysSince from "./locales/en-GB/daysSince.json";
import enGbFarmCover from "./locales/en-GB/farmCover.json";
import enGbFarms from "./locales/en-GB/farms.json";
import enGbFields from "./locales/en-GB/fields.json";
import enGbForecast from "./locales/en-GB/forecast.json";
import enGbForecastAnalysis from "./locales/en-GB/forecastAnalysis.json";
import enGbSatelliteDetectionAnalysis from "./locales/en-GB/satelliteDetectionAnalysis.json";
import enGbHome from "./locales/en-GB/home.json";
import enGbManage from "./locales/en-GB/manage.json";
import enGbNotes from "./locales/en-GB/notes.json";
import enGbProfile from "./locales/en-GB/profile.json";
import ptPtAdmin from "./locales/pt-PT/admin.json";
import ptPtAnalysis from "./locales/pt-PT/analysis.json";
import ptPtCommon from "./locales/pt-PT/common.json";
import ptPtAuth from "./locales/pt-PT/auth.json";
import ptPtDashboard from "./locales/pt-PT/dashboard.json";
import ptPtDaysSince from "./locales/pt-PT/daysSince.json";
import ptPtFarmCover from "./locales/pt-PT/farmCover.json";
import ptPtFarms from "./locales/pt-PT/farms.json";
import ptPtFields from "./locales/pt-PT/fields.json";
import ptPtForecast from "./locales/pt-PT/forecast.json";
import ptPtForecastAnalysis from "./locales/pt-PT/forecastAnalysis.json";
import ptPtSatelliteDetectionAnalysis from "./locales/pt-PT/satelliteDetectionAnalysis.json";
import ptPtHome from "./locales/pt-PT/home.json";
import ptPtManage from "./locales/pt-PT/manage.json";
import ptPtNotes from "./locales/pt-PT/notes.json";
import ptPtProfile from "./locales/pt-PT/profile.json";

export const DEFAULT_LANGUAGE = "en-GB";
export const SUPPORTED_LANGUAGES = [
  {
    code: "en-GB",
    label: "🇬🇧",
    nameKey: "language.englishUk",
    momentLocale: "en-gb",
  },
  {
    code: "pt-PT",
    label: "🇵🇹",
    nameKey: "language.portuguesePortugal",
    momentLocale: "pt",
  },
];

const STORAGE_KEY = "pasture-ai-language";

const normaliseLanguage = (language) => {
  if (language === "en" || language === "en-GB") return "en-GB";
  if (language === "pt" || language === "pt-PT") return "pt-PT";
  return DEFAULT_LANGUAGE;
};

const getInitialLanguage = () => {
  const savedLanguage = window.localStorage.getItem(STORAGE_KEY);
  if (savedLanguage) return normaliseLanguage(savedLanguage);

  return normaliseLanguage(window.navigator.language);
};

const setDocumentLanguage = (language) => {
  document.documentElement.lang = language;
};

const initialLanguage = getInitialLanguage();
setDocumentLanguage(initialLanguage);

i18n.use(initReactI18next).init({
  resources: {
    "en-GB": {
      admin: enGbAdmin,
      analysis: enGbAnalysis,
      common: enGbCommon,
      auth: enGbAuth,
      dashboard: enGbDashboard,
      daysSince: enGbDaysSince,
      farms: enGbFarms,
      farmCover: enGbFarmCover,
      fields: enGbFields,
      forecast: enGbForecast,
      forecastAnalysis: enGbForecastAnalysis,
      satelliteDetectionAnalysis: enGbSatelliteDetectionAnalysis,
      home: enGbHome,
      manage: enGbManage,
      notes: enGbNotes,
      profile: enGbProfile,
    },
    "pt-PT": {
      admin: ptPtAdmin,
      analysis: ptPtAnalysis,
      common: ptPtCommon,
      auth: ptPtAuth,
      dashboard: ptPtDashboard,
      daysSince: ptPtDaysSince,
      farms: ptPtFarms,
      farmCover: ptPtFarmCover,
      fields: ptPtFields,
      forecast: ptPtForecast,
      forecastAnalysis: ptPtForecastAnalysis,
      satelliteDetectionAnalysis: ptPtSatelliteDetectionAnalysis,
      home: ptPtHome,
      manage: ptPtManage,
      notes: ptPtNotes,
      profile: ptPtProfile,
    },
  },
  lng: initialLanguage,
  fallbackLng: DEFAULT_LANGUAGE,
  supportedLngs: SUPPORTED_LANGUAGES.map(({ code }) => code),
  defaultNS: "common",
  ns: [
    "admin",
    "analysis",
    "common",
    "auth",
    "dashboard",
    "daysSince",
    "farms",
    "farmCover",
    "fields",
    "forecast",
    "forecastAnalysis",
    "satelliteDetectionAnalysis",
    "home",
    "manage",
    "notes",
    "profile",
  ],
  interpolation: {
    escapeValue: false,
  },
});

i18n.on("languageChanged", (language) => {
  const supportedLanguage = normaliseLanguage(language);
  window.localStorage.setItem(STORAGE_KEY, supportedLanguage);
  setDocumentLanguage(supportedLanguage);
});

export default i18n;
